<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="waiting-screen" v-show="!isLoading">
          <div v-if="getComment">
            <div class="widget lazur-bg p-lg text-center">
              <div class="m-b-md">
                <i class="fa fa-thumbs-up fa-4x"></i>
                <h1 class="m-xs">Détail du virement ext:</h1>
                <h3 class="font-bold no-margins">
                  Par: <strong>{{ externalTransferHistory.user }}</strong>
                </h3>
                <h3 class="font-bold no-margins">
                  Fait le: <strong>{{ externalTransferHistory.date }}</strong>
                </h3>
                <h3 class="font-bold no-margins">
                  Commentaire:
                  <strong>
                    <span>{{ externalTransferHistory.comment }} </span>
<!--                    <span>{{ externalTransferHistory.comment }} <i class="fa fa-files-o fa-copy" @click.stop.prevent="copyTestingCode"></i></span>-->
<!--                    <input type="hidden" id="testing-code" :value="externalTransferHistory.comment">-->
                  </strong>
                </h3>
              </div>
            </div>
            <div class="alert alert-success alert-dismissable">
              <button aria-hidden="true" data-dismiss="alert" class="close" type="button">×</button>
              <strong>Virement ext terminé.</strong>
            </div>
          </div>
          <div v-else class="waiting-screen-body">
            <div class="alert alert-info">
              <strong>Info:</strong> Confirmer le virement externe pour finaliser le virement.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button type="button"
                class="pull-left btn btn-w-m btn-primary"
                @click="$parent.toggleBlock(2)">Précédent</button>
        <button v-if="externalTransferHistory.comment === null" type="button"
                class="btn btn-w-m btn-primary pull-right" @click="onSubmit">Confirmer virements Ext</button>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: 'ReservationModule',
  props: {
    orderId: {
      type: String,
    },
    paymentMode: {
      type: Number,
    },
  },
  data() {
    return {
      time: 0,
      duration: 3000,
      isValid: false,
      externalTransferHistoryComment: false,
      externalTransferHistory: {
        date: "",
        user: "",
        comment: "",
        command: ""
      },
      paymentControllInfo: {
        status: "",
      },
    }
  },
  computed: {
    isLoading () {
      if (this.externalTransferHistoryComment) return true
      else return false
    },
    getComment () {
      let comment = false
      setTimeout(function () {
      }, 100)
      if(this.externalTransferHistory.comment !== null) comment = true
      return comment
    },
    progressBarStyle() {
      return 'width: ' + (100 * this.time) / this.duration + '%;'
    },
    externalTransferMutation () {
      return gql`
          mutation {
            externalTransfer(orderId: ${this.orderId})
            {
              date
              user
              comment
              command
            }
          }`
    },
  },
  async created () {
    await this.getExternalTransferHistory()
    await this.getPaymentControlQuery()
  },
  methods: {
    async getPaymentControlQuery () {
      const PaymentControlInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getPaymentControl (orderId: ${this.orderId}) {
                        status
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.paymentControllInfo.status = PaymentControlInfo.data.getPaymentControl.status

    },
    async getExternalTransferHistory () {
      this.externalTransferHistoryComment = true
      const externalTransferHistory = await this.$apollo.query({
        query: gql`
              query {
                     externalTransferHistory (orderId: ${this.orderId}) {
                        date,
                        user,
                        comment,
                        command,
                    }
              }`,
        fetchPolicy: 'no-cache'
      })
      this.externalTransferHistory.date = externalTransferHistory.data.externalTransferHistory.date
      this.externalTransferHistory.user = externalTransferHistory.data.externalTransferHistory.user
      this.externalTransferHistory.comment = externalTransferHistory.data.externalTransferHistory.comment
      this.externalTransferHistory.command = externalTransferHistory.data.externalTransferHistory.command
      this.externalTransferHistoryComment = false

    },
    async onSubmit () {
      let result = await this.$validator.validateAll()
      if (result) {
        this.$apollo.mutate({
          mutation: this.externalTransferMutation
        }).then(() => {
          this.showBanner('success', `Succès: le virement externe terminé`)
          if (this.paymentMode === 3){
            if (this.$route.name === 'command-details-virement-lemonway-b') this.$router.push({name: 'command-details-virement-lemonway'})
            else this.$router.push({name: 'command-details-virement-lemonway-b'})
          }
          else {
            if (this.$route.name === 'command-details-lemonway') this.$router.push({name: 'command-details-lemonway-b'})
            else this.$router.push({name: 'command-details-lemonway'})
          }
          //location.reload(true)
          //this.$parent.toggleBlock(3)
        })
      }
    },
  },
  apollo: {
  }
}
</script>